<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Coloca tu correo de nexus
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-divider ></v-divider>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-form @submit.prevent="submit()">
                      <v-text-field
                        v-model="nexus_email"
                        v-validate="'required'"
                        data-vv-name="nexus_email"
                        data-vv-as="Correo de nexus"
                        :error-messages="errors.collect('nexus_email')"
                        label="Correo de nexus"
                        color="black"
                        type="email">
                      </v-text-field>
                      <v-btn class="k-orange-linear white--text" type="submit" @click="submit()" block large>ENTRAR</v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')"  width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LogRocket from 'logrocket';
import Sidebar from '@/components/login/Sidebar';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  data() {
    return {
      nexus_email: '',
    };
  },
  methods: {
    submit() {
      this.axios.patch(`users/${this.$auth.user().id}`, {
        nexus_email: this.nexus_email,
      }).then(() => {
        this.$auth.refresh().then(async (response) => {
          const user = this.$auth.user();
          user.nexus_email = this.nexus_email;
          if (process.env.NODE_ENV === 'production') {
            LogRocket.identify(user.id, {
              name: `${user.first_name} ${user.last_name}`,
              email: user.email,
            });
          }
          this.$router.push({ name: 'home' });
        });
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/NexusEmail.vue